// plugin.js
import FormField from './components/FormField.vue';
import moment from 'moment';
import './style/scss/vform.scss';

// This exports the plugin object.
export default {
    // The install method will be called with the Vue constructor as
    // the first argument, along with possible options
    install (Vue, options) {
        // Add or modify global methods or properties.
        // Vue.yourMethod = (value) => value
        // Add a component or directive to your plugin, so it will be installed globally to your project.


        Object.defineProperties(Vue.prototype, {
            $moment: {
                value: moment
            },
        });

        // Add $plugin instance method directly to Vue components
        Vue.component('FormField', FormField);

        // Add Vue instance methods by attaching them to Vue.prototype.
        Vue.prototype.classPrefix = options.classPrefix;
        Vue.prototype.i18n = options.i18n;
    }
}